<!-- Navigation -->
<ng-container *ngIf="isScreenSmall">
    <fakturnia-vertical-navigation class="light bg-white print:hidden" [mode]="'over'" [name]="'mainNavigation'"
        [navigation]="navigation" [opened]="false">
        <!-- Navigation header hook -->
        <ng-container fakturniaVerticalNavigationContentHeader>
            <a [routerLink]="'/'">
                <!-- Logo -->
                <div class="flex items-center justify-center gap-2.5 py-6 px-8">
                    <img class="h-8 w-8 rounded-lg object-contain" src="assets/images/logo-a.png" alt="Logo Fakturnia" width="32" height="32">
                    <span class="text-2xl font-semibold tracking-tight text-gray-900">Fakturnia</span>
                </div>
            </a>
        </ng-container>
    </fakturnia-vertical-navigation>
</ng-container>

<!-- Wrapper -->
<div class="flex flex-col flex-auto w-full min-w-0">
    <!-- Header -->
    <div
        class="relative flex flex-0 items-center w-full h-16 sm:h-18 px-4 md:px-6 z-49 shadow dark:shadow-none dark:border-b bg-card dark:bg-transparent print:hidden">

        <ng-container *ngIf="!isScreenSmall">
            <ng-container fakturniaVerticalNavigationContentHeader>
                <div class="flex items-center px-8">
                    <a [routerLink]="'/'" class="flex items-center gap-2.5">
                        <img class="h-8 w-8 rounded-lg object-contain" src="assets/images/logo-a.png" alt="Logo Fakturnia" width="32" height="32">
                        <span class="text-2xl font-semibold tracking-tight text-gray-900 dark:text-white">Fakturnia</span>
                    </a>
                </div>
            </ng-container>
            <!-- Horizontal navigation -->
            <fakturnia-horizontal-navigation class="mr-2" [name]="'mainNavigation'" [navigation]="navigation">
            </fakturnia-horizontal-navigation>
        </ng-container>

        <!-- Navigation toggle button -->
        <ng-container *ngIf="isScreenSmall">
            <button mat-icon-button (click)="toggleNavigation('mainNavigation')">
                <mat-icon [svgIcon]="'heroicons_outline:bars-3'"></mat-icon>
            </button>
        </ng-container>


        <!-- Components -->
        <div class="flex items-center pl-2 ml-auto space-x-0.5 sm:space-x-2">

            <button *ngIf="isLoggedIn" mat-icon-button [matMenuTriggerFor]="helpMenu" data-tour-id="pomoc" matTooltip="Pomoc">
                <mat-icon [svgIcon]="'tabler_outline:lifebuoy'"></mat-icon>
            </button>
            <mat-menu #helpMenu="matMenu">
                <button mat-menu-item (click)="startGuidedTour()">
                    <mat-icon [svgIcon]="'tabler_outline:walk'"></mat-icon>
                    <span>Uruchom przewodnik</span>
                </button>
                <a mat-menu-item href="https://pomoc.fakturnia.pl" target="_blank">
                    <mat-icon [svgIcon]="'tabler_outline:book'"></mat-icon>
                    <span>Baza wiedzy</span>
                </a>
                <a mat-menu-item href="https://fakturnia.pl/kontakt" target="_blank">
                    <mat-icon [svgIcon]="'tabler_outline:mail'"></mat-icon>
                    <span>Kontakt</span>
                </a>
            </mat-menu>

            <notifications-bell *ngIf="isLoggedIn"></notifications-bell>

            <fakturnia-fullscreen *ngIf="isLoggedIn" class="hidden md:block"></fakturnia-fullscreen>
            <user *ngIf="isLoggedIn"></user>

        </div>

        <mat-progress-bar class="absolute bottom-0 -mx-6 px-0" *ngIf="isSynchronizing"
            mode="indeterminate"></mat-progress-bar>
    </div>

    <!-- Content -->
    <div class="flex flex-col flex-auto w-full  overflow-x-hidden">
        <!-- *ngIf="true" layout changes won't be registered without *ngIf=true! -->
        <router-outlet *ngIf="true"></router-outlet>
    </div>

</div>